'use strict'

module.exports = (function () {
    /**
    * @ngdoc method
    * @name featuredServiceBlocks
    * @description Initializes featured fervice blocks
    * These are the blocks where you click on a left block and the details are shown on the right
    **/

    var initialize = function (selector) {
        $('#featuredServices ul').each(function () {
            var $this = $(this);
            $this.children('li').each(function (i) {
                $this.attr('data-pair', 'featitem-' + (i + 1));
            });
        });

        $('#featuredServices ul > li:first-child').addClass("selected");
        $('#featuredServices li.feature-item').on('mouseover', function () {
            var $this = $(this);
            var matchingItem = $this.attr('data-pair');
            $('#featuredServices ul > li').removeClass("selected");
            $this.addClass("selected");
            $('.related-item[data-pair = ' + matchingItem + ']').addClass("selected");
        })
    }

    return {
        initialize: initialize
    };
}())